import { loadProductGuide, addProductGuide } from '@/api/guide';
import { queryGuideInfo } from '@/api/project';
import { getZhGuideInstance } from '@/api/guide';

export default {
  namespaced: true,
  state: {
    guideInfoList: [],
    guideStepData:[],
    guideInfo: null,
    currentGuide: null,
    lightBulbShowing: false,
    guideTask: []
  },
  mutations: {
    SET_LIGHT_BULB_SHOWING(state, data){
      state.lightBulbShowing = data;
    },
    SET_GUIDE_INFO_ALL(state, data) {
      state.guideInfo = data;
    },
    SET_CURRENT_GUIDE(state, data) {
      state.currentGuide = data;
    },
    SET_GUIDE_INFO(state, data) {
      state.guideInfoList = data;
    },
    SET_GUIDE_STEP(state, data) {
      state.guideStepData = data;
    },
    SET_GUIDE_TASK(state, data = []) {
      state.guideTask = data;
    }
  },
  actions: {
    // 初始化记录指引数据
    initGuide({ commit }, { guideInfo, currentGuide }) {
      commit('SET_GUIDE_INFO_ALL', guideInfo);
      commit('SET_CURRENT_GUIDE', currentGuide);
    },
    /* 更新记录 */
    async updateGuideRecords({ state, commit }, data) {
      const guideInfo = { ...state.guideInfo };
      const index = guideInfo.guideDetail?.findIndex(f => f.module === data.module);
      guideInfo.guideDetail[index] = data;
      guideInfo.step = guideInfo.guideDetail?.findIndex(f => !!f.done);
      guideInfo.totalStep = guideInfo.guideDetail.reduce((t, c) => c.totalStep + t, 0);

      commit('SET_GUIDE_INFO_ALL', guideInfo);
      commit('SET_CURRENT_GUIDE', data);

      await addProductGuide({
        ...guideInfo,
        guideDetail: JSON.stringify(guideInfo.guideDetail)
      });
    },
    clear({ commit }) {
      commit('SET_GUIDE_INFO', null);
      commit('SET_CURRENT_GUIDE', null);
    },
    async queryGuideInfo({ state, commit }, update) {
      if (!update && state.guideInfoList.length > 0) {
        return state.guideInfoList;
      }
      const data = await queryGuideInfo();
      commit('SET_GUIDE_INFO', data);
      return data;
    },
    async queryGuideStepInfo({ state, commit }, update) {
      if (!update && state.guideStepData.length > 0) {
        return state.guideStepData;
      }
      const data = await loadProductGuide({ targetChoice: 'FUNCTION_EXPLORING' });
      commit('SET_GUIDE_STEP', data || []);
      return data || [];
    },
    async queryGuideTask({ state, commit }, update) {
      if (!update && state.guideTask.length > 0) {
        return state.guideTask;
      }
      const data = await getZhGuideInstance({ targetChoice: 'TASK_GUIDE' });
      commit('SET_GUIDE_TASK', data?.userQuestList || []);
      return data?.userQuestList || [];
    }
  },
  getters:{
    isDoneGuideByType (state) {
      return (type) =>{
        return state.guideInfoList?.some(item => item.guideType === type && item.enabled);
      };
    },
    currentStepData(state) {
      return state.guideStepData.find(item=>item.step === 10);
    },
    isShowGuide(state, getters) {
      return getters.currentStepData?.guideDetail && JSON.parse(getters.currentStepData?.guideDetail).isShowGuide ;
    }
  }
};


